export default __webpack_public_path__ + "static/media/lock.3a55a760.svg";